import Cookies from 'js-cookie'
import AppConfig from '@/config'
import { COOKIE_KEYS, getAuthToken } from '@/constants/storageKeys'

const GUEST_ID_TTL_DAYS = 365

export const GUEST_ID_HEADER = 'X-Guest-Id'

function generateGuestId(): string {
	// crypto.randomUUID есть только в secure-контексте (https / localhost),
	// поэтому для http:// по IP в локальной сети собираем uuid v4 руками.
	if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()
	const bytes = new Uint8Array(16)
	crypto.getRandomValues(bytes)
	bytes[6] = (bytes[6] & 0x0f) | 0x40
	bytes[8] = (bytes[8] & 0x3f) | 0x80
	const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export function getGuestId(): string | undefined {
	return Cookies.get(COOKIE_KEYS.GUEST_ID)
}

export function ensureGuestId(): string | null {
	if (AppConfig.authMode !== 'internal') return null // в external-режиме гостей не бывает
	if (getAuthToken()) return null // авторизованному guest_id не нужен
	const existing = getGuestId()
	if (existing) return existing
	const id = generateGuestId()
	Cookies.set(COOKIE_KEYS.GUEST_ID, id, {
		expires: GUEST_ID_TTL_DAYS,
		path: '/',
		sameSite: 'Lax',
		secure: window.location.protocol === 'https:'
	})
	return id
}

export function clearGuestId(): void {
	Cookies.remove(COOKIE_KEYS.GUEST_ID, { path: '/' })
}

/**
 * Дублирует guest_id заголовком — бэк читает оба канала.
 * Пусто у авторизованного и в external-режиме: там cookie не создаётся.
 */
export const guestHeader = (): Record<string, string> => {
	const id = getGuestId()
	return id ? { [GUEST_ID_HEADER]: id } : {}
}
